import axios from "axios";
import store from "../store";

class Database {
	getCredentials(password) {
		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/database/credentials",
					{
						password: password,
					},
					{
						headers: {
							Authorization: "bearer " + jwt,
						},
					}
				)
				.then(function (response) {
					resolve(response.data.response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	get(action, table, params) {
		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/database",
					{
						action: action,
						table: table,
						params: params,
					},
					{
						headers: {
							Authorization: "bearer " + jwt,
						},
					}
				)
				.then(function (response) {
					resolve(response.data.response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	request(request, user_params) {
		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/database/request",
					{
						request,
						user_params
					},
					{
						headers: {
							Authorization: "bearer " + jwt,
						},
					}
				)
				.then(function (response) {
					resolve(response.data.response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}
}

export default new Database();
